



































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {}
